import { render, staticRenderFns } from "./FscPageHeader.vue?vue&type=template&id=24f0608e&"
import script from "./FscPageHeader.vue?vue&type=script&lang=ts&"
export * from "./FscPageHeader.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports